import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Blog1 from '../components/BlogComponents/Blog1';
import Blog2 from '../components/BlogComponents/Blog2';
import Blog3 from '../components/BlogComponents/Blog3';
import NotFound from './NotFound';

const keys = ['title1', 'title2', 'title3'];
const components = [Blog1, Blog2, Blog3];
const slugify = text => text.split(' ').slice(0, 4).join(' ').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9 ]/g, '').replace(/\s+/g, '-');

export default function BlogDetails() {
  const { id } = useParams();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const index = keys.findIndex(key => ['en', 'swe'].some(lang => slugify(i18n.getFixedT(lang)(key)) === id));
  const correctSlug = index >= 0 ? slugify(t(keys[index])) : '';
  useEffect(() => {
    if (correctSlug && correctSlug !== id) navigate('/blogg/' + correctSlug, { replace: true });
  }, [correctSlug, id, navigate]);
  if (index < 0) return <NotFound />;
  const BlogComponent = components[index];
  return <main>
    <BlogComponent />
  </main>;
}
